const API_BASE_URL = import.meta.env.VITE_API_URL || '/web/rest';

const getLang = (): string => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith('lang='));
  return match?.split('=')[1] || 'zh';
};

const getHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('adminToken');
  return {
    'Content-Type': 'application/json',
    'Accept-Language': getLang(),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const handleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const api = {
  get: <T>(path: string): Promise<T> =>
    fetch(`${API_BASE_URL}${path}`, {
      headers: getHeaders(),
      credentials: 'include',
    }).then((r) => handleResponse<T>(r)),

  post: <T>(path: string, body?: unknown): Promise<T> =>
    fetch(`${API_BASE_URL}${path}`, {
      method: 'POST',
      headers: getHeaders(),
      credentials: 'include',
      body: JSON.stringify(body ?? {}),
    }).then((r) => handleResponse<T>(r)),

  patch: <T>(path: string, body: unknown): Promise<T> =>
    fetch(`${API_BASE_URL}${path}`, {
      method: 'PATCH',
      headers: getHeaders(),
      credentials: 'include',
      body: JSON.stringify(body),
    }).then((r) => handleResponse<T>(r)),

  put: <T>(path: string, body: unknown): Promise<T> =>
    fetch(`${API_BASE_URL}${path}`, {
      method: 'PUT',
      headers: getHeaders(),
      credentials: 'include',
      body: JSON.stringify(body),
    }).then((r) => handleResponse<T>(r)),

  delete: <T>(path: string): Promise<T> => {
    const token = localStorage.getItem('adminToken');
    return fetch(`${API_BASE_URL}${path}`, {
      method: 'DELETE',
      headers: {
        'Accept-Language': getLang(),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: 'include',
    }).then((r) => handleResponse<T>(r));
  },

  upload: <T>(
    path: string,
    file: File,
    params?: Record<string, string>,
  ): Promise<T> => {
    const token = localStorage.getItem('adminToken');
    const formData = new FormData();
    formData.append('file', file);
    const queryStr = params ? '?' + new URLSearchParams(params).toString() : '';
    return fetch(`${API_BASE_URL}${path}${queryStr}`, {
      method: 'POST',
      headers: {
        'Accept-Language': getLang(),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: 'include',
      body: formData,
    }).then((r) => handleResponse<T>(r));
  },
};
